import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles/index';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: unit * 2,
    },
    photo: {
        width: '100px',
        height: '100px',
        borderRadius: '50%',
    },
    container: {
        textAlign: 'center',
    },
});

function TakenPhotoData(props) {
    return (
        <Grid
            container
            spacing={0}
        >
            <Grid
                item
                xs={12}
                sm={12}
            >
                <Grid
                    container
                    spacing={0}
                >
                    <Grid
                        item
                        xs={12}
                        sm={12}
                    >
                        <div className={props.classes.container}>
                            <img src={props.photoUrl} alt="" className={props.classes.photo} />
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                item
                xs={12}
                sm={12}
            >
                <Button
                    className={props.classes.button}
                    onClick={() => {
                        props.setApplicantTakenPhoto(false);
                    }}
                >
                    Retake
                </Button>
            </Grid>
        </Grid>
    );
}

TakenPhotoData.propTypes = {
    setApplicantTakenPhoto: PropTypes.func.isRequired,
    photoUrl: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TakenPhotoData);



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantIdVerification/components/TakenPhotoData.js